<template>
    <PopTableList
        :form_data_seo="form_data_seo_pop"
        :form_data="form_data_pop"
        :zIndex="2000"
        :columns="pop_columns"
        :visible.sync="user_visible"
        :rowSelection="rowSelection"
        :get_table_list="get_table_list"
        :submit_preprocessing="submit_preprocessing"
        @submit="submit"
        rowKey="id"
		ref="list"
		:is_created_get_list="JSON.stringify(seo_data) === '{}'"
    >

    </PopTableList>
</template>

<script>
import PopTableList from './PopTableList'
import { getCustomerList } from "@/api/customer";
import props_pop from './props/pop'
import table_pop from './props/table'
const columns = [
    {
        title: "客户ID",
        dataIndex: "id"
    },
    {
        title: "客户名称",
        dataIndex: "name"
    },
    {
        title: "客户地址",
        dataIndex: "address"
    }
]

export default {
    name: 'SelectUser',
    components: {
        PopTableList,
    },
    props: {
        ...props_pop,
        ...table_pop,
		seo_data:{
			type:Object,
			data:()=>{
				return {
					// customer_type:'', // eg: customer_type:'dealer'，目前该字段只有dealer值，用于只筛选出经销商
				}
			}
		}
    },

    data() {
        return {
            user_visible: false,
            get_table_list: getCustomerList,
            pop_columns: columns,
            submit_preprocessing: {
            },
            form_data_pop: {
                title: '请选择客户'
            },
            form_data_seo_pop: {
                ...this.$config.form_data_seo,
                list: [
                    {
                        type: "text",
                        name: "keyword",
                        title: "关键词",
                        placeholder: "客户名称/地址/ID",
                        options: {}
                    }
                ]
            },
            select_user: {}
        }
    },
    computed: {
        rowSelection() {
            return {
                onChange: (selectedRowKeys, selectedRows) => {
                    this.select_user = selectedRows[0];
                },
                type: 'radio',
                selections: false,
                hideDefaultSelections: true,
                getCheckboxProps: record => {
                    return {
                        props: {
                            checked: record.id == this.select_user.id ? true : false,
                            name: record.username ? record.username.toString() : '', // getCustomerList接口给的username在没有值的情况下会传null过来，为了避免toString()方法的报错，因此作额外判断
                        }
                    }
                }
            };
        },
    },
    watch: {
        visible(new_value) {
            this.user_visible = new_value
			// 只有当modal显示时真正的dom才会开始加载，在$nextTick之后将父级的搜索内容填充进table_list中
			this.$refs.list.$nextTick(()=>{
				let list = this.$refs.list.$refs.table_list;
				list.fixed_seo_data = this.seo_data;
				list.get_list();
			})
        },
        user_visible(new_value) {
            this.$emit('update:visible', new_value)
        },
    },
    created() {
        
    },
    methods: {
        submit() {
            this.$emit('submit', {
                data: this.select_user
            })
        }
    }
}
</script>